import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import electricityAPI from '../../../../services/modules/IP/electricityAPI';
import electricBoard from '../../../../services/modules/JSON/electricBoard';
import NonRenewableForm from '../../../Forms/NonRenewable';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const NonRenewableBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        electricityAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      electricBoard()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          onValuesChange(true);
        } else {
          const fData: any = record?.fields ?? undefined;
          const customFromData: any = {
            _id: '',
            facility: record?.facility,
            timeFrameData: fData?.timeFrameData ?? [],
            year: record?.year,
            electricityBoard: fData?.electricityBoard ?? undefined
          };

          caForm.setFieldsValue(customFromData);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <NonRenewableForm defaultDisplayStep={true} />
    </Form>
  );
};

export default NonRenewableBills;
